"use client";
import { progressAtom } from "@/hooks/headerHooks";
import { showSideMenuAtom } from "@/hooks/showSideMenuAtom";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import BaseToggleSwitch from "./BaseToggleSwitch";
import { storeLangCookie } from "@/utils/functions/cookieOperations";
import { usePathname } from "next/navigation";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import useIsRtl from "@/hooks/useIsRtl";
import { useLang } from "@/providers/langProvider";

const LanguageSwitch = ({ mobile = false }) => {
  const router = useRouter();
  const pathName = usePathname();
  const redirectedPathName = (locale: string) => {
    if (!pathName) return "/";
    const segments = pathName.split("/");
    if (["ar", "en"].includes(segments[1])) segments[1] = locale;
    else {
      segments.splice(1, 0, locale);
    }

    return segments.join("/");
  };
  const isRtl = useIsRtl();
  const [routerProgress] = useAtom(progressAtom);
  const [, setShowSideMenu] = useAtom(showSideMenuAtom);
  const [toggled, setToggled] = useState(!isRtl);
  const [ready, setReady] = useState(false);
  const lang = useLang();
  const handleLangChanged = () => {
    storeLangCookie(lang);
    setToggled(!toggled);
  };
  // useEffect(() => {
  //   switched && handleLangChanged();
  // }, [switched]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (ready) {
      router.push(redirectedPathName(isRtl ? "en" : "ar"));
      router.refresh();
      mobile && setShowSideMenu(false);
    } else setReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggled]);
  return (
    <BaseToggleSwitch
      disabled={routerProgress}
      mobile={mobile}
      labels={["ع", "EN"]}
      toggled={toggled}
      onChange={handleLangChanged}
    />
  );
};

export default LanguageSwitch;
